import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  drawerFooter: {
    flex: "none",
    padding: "16px 24px",
    borderTop: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
  },
  createBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid var(--app-primary)",
    backgroundColor: "var(--app-primary)",
    height: 44,
    width: "100%",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-on-primary)",
    ":hover": {
      backgroundColor: "var(--app-primary)",
      opacity: 0.8,
    },
  },
  cancelBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    height: 44,
    width: "100%",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-text)",
    ":hover": {
      backgroundColor: "var(--app-surface)",
      opacity: 0.8,
    },
  },
  createBtnPrev: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid var(--app-primary)",
    backgroundColor: "var(--app-primary)",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-on-primary)",
    ":hover": {
      backgroundColor: "var(--app-primary)",
      opacity: 0.8,
    },
  },
  cancelBtnPrev: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-text)",
    ":hover": {
      backgroundColor: "var(--app-surface)",
      opacity: 0.8,
    },
  },
  sectionCard: {
    width: "100%",
    marginBottom: 20,
    padding: "20px 20px 24px",
    borderRadius: 12,
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
  },
  sectionHeader: {
    marginBottom: 16,
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "Inter",
    textTransform: "uppercase",
    letterSpacing: "0.02em",
    color: "var(--app-text-muted)",
     "& .mantine-Text-root": {
    color: "var(--app-text)",
  },
    "& svg": {
      color: "var(--app-text-faint)",
    },
  },
  fieldLabel: {
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Inter",
    color: "var(--app-text)",
    marginBottom: 6,
  },
  subtext: {
    fontSize: 12,
    fontFamily: "Inter",
    color: "var(--app-text-muted)",
    marginTop: 6,
  },
  optionalLbl: {
    fontWeight: 400,
    color: "var(--app-text-muted)",
  },
  // Shown when a generate attempt matched no notes — the drawer stays on the
  // form so the user can widen the range instead of getting an empty PDF.
  emptyResultAlert: {
    display: "flex",
    alignItems: "flex-start",
    gap: 9,
    marginBottom: 20,
    padding: "12px 14px",
    borderRadius: 10,
    border: "1px solid #FEDF89",
    backgroundColor: "#FFFAEB",
    color: "#B54708",
    "& svg": {
      flex: "none",
      marginTop: 1,
    },
    "& .mantine-Text-root": {
      fontSize: 13,
      fontFamily: "Inter",
      lineHeight: 1.45,
      color: "#B54708",
    },
  },
  selectAllLink: {
    fontSize: 12.5,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#B4700A",
    padding: 0,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  advTrigger: {
    display: "inline-flex",
    alignItems: "center",
    gap: 7,
    padding: "7px 12px",
    marginBottom: 12,
    borderRadius: 8,
    border: "1px solid #e7e9ee",
    // backgroundColor: "var(--app-surface)",
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-text-muted)",
    "&:hover": {
      backgroundColor: "var(--app-bg)",
    },
  },
  advTriggerActive: {
    backgroundColor: "var(--app-primary-soft, #FFF6E9)",
    borderColor: "var(--app-primary-bd, #FFE2B8)",
    color: "#B4700A",
    "& svg": {
      color: "#B4700A",
    },
  },
  advCloseBtn: {
    display: "inline-flex",
    color: "var(--app-text-muted)",
    "&:hover": {
      color: "var(--app-primary)",
    },
  },
  segToggle: {
    display: "flex",
    gap: 8,
    maxWidth: 240,
  },
  segToggleBtn: {
    flex: 1,
    textAlign: "center",
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    borderRadius: 8,
    padding: 9,
    fontSize: 13,
    fontFamily: "Inter",
    color: "var(--app-text-muted)",
  },
  segToggleBtnActive: {
    backgroundColor: "var(--app-primary-soft, #FFF6E9)",
    borderColor: "var(--app-primary-bd, #FFE2B8)",
    color: "#7A4A00",
    fontWeight: 600,
  },

  //   ************* Report Preview / Report Ready *************
  previewFrame: {
    width: "100%",
    height: "70vh",
    border: "none",
    borderRadius: 8,
    display: "block",
  },
  doneWrap: {
    textAlign: "center",
    padding: "48px 24px",
  },
  doneIcon: {
    width: 58,
    height: 58,
    borderRadius: "50%",
    background: "#ECFDF3",
    color: "#027A48",
    display: "grid",
    placeItems: "center",
    margin: "0 auto 18px",
  },
  doneTitle: {
    fontSize: 17,
    fontWeight: 700,
    fontFamily: "Inter",
    color: "var(--app-text)",
  },
  doneSub: {
    fontSize: 13,
    fontFamily: "Inter",
    color: "var(--app-text-muted)",
    margin: "6px 0 20px",
    lineHeight: 1.5,
  },
  fileChip: {
    maxWidth: 360,
    margin: "0 auto 22px",
    border: "1px solid var(--app-border)",
    borderRadius: 12,
    backgroundColor: "var(--app-surface)",
    padding: "12px 14px",
    textAlign: "left",
  },
  fileIco: {
    flex: "none",
    width: 38,
    height: 38,
    borderRadius: 8,
    background: "#FEF3F2",
    color: "#B42318",
    display: "grid",
    placeItems: "center",
    fontSize: 10.5,
    fontWeight: 800,
    letterSpacing: "0.02em",
  },
  fileName: {
    fontSize: 13.5,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-text)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  fileMeta: {
    fontSize: 12,
    fontFamily: "Inter",
    color: "var(--app-text-muted)",
    marginTop: 2,
  },

  inputField: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "var(--app-text)",
      marginBottom: 6,
    },
    "& .mantine-Input-wrapper": {
      padding: "08px 12px",
      height: 38,
      borderRadius: 8,
      border: "1px solid var(--app-border)",
      background: "transparent",
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
      "& input, & .mantine-PasswordInput-input": {
        height: "100%",
        border: "none",
        padding: "0px",
        background: "transparent",
        minHeight: "unset",
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "var(--app-text)",

        "&:-webkit-autofill": {
          boxShadow: "0 0 0px 1000px transparent inset !important",
          WebkitTextFillColor: "var(--app-text)",
          transition: "background-color 5000s ease-in-out 0s",
        },

        "&::placeholder": {
          color: "var(--app-text-muted)",
        },
      },
    },
    "& .mantine-Select-wrapper": {
      padding: 0,
      "& .mantine-Select-input": {
        paddingLeft: 12,
        paddingRight: 36,
      },
    },
  },
  multiSelect: {
    "& .mantine-MultiSelect-rightSection": {
      width: "fit-content",
      right: 13
    },
    "& .mantine-MultiSelect-input": {
      minHeight: 44,
      padding: "6px 40px 6px 8px",
      border: "1px solid var(--app-border)",
      borderRadius: 8,
      "&:focus-within": {
        borderColor: "var(--app-primary)",
        boxShadow: "0 0 0 3px rgba(255,175,74,.2)",
      },
      "& .mantine-MultiSelect-values": {
        overflowY: "auto",
        minHeight: "unset",
        gap: 6,
      },
    },
    "& .mantine-Input-wrapper": {
      height: "auto",
      padding: 0,
      border: "none",
      boxShadow: "none",
    },
    "& .mantine-MultiSelect-value": {
      backgroundColor: "var(--app-primary-soft, #FFF6E9)",
      border: "1px solid var(--app-primary-bd, #FFE2B8)",
      color: "#7A4A00",
      borderRadius: 16,
      padding: "3px 4px 3px 11px",
    },
    "& .mantine-MultiSelect-defaultValueLabel": {
      fontSize: 13,
      fontFamily: "Inter",
      color: "#7A4A00",
    },
    "& .mantine-MultiSelect-defaultValueRemove": {
      color: "#7A4A00",
      opacity: 0.55,
      width: 16,
      minWidth: 16,
      height: 16,
      "&:hover": {
        opacity: 1,
        backgroundColor: "transparent",
      },
    },
  },

  //   ************* Date Range Picker *************
  buttonStyle: {
    margin: "6px 0 0 0",
    width: "100%",
    height: 40,
    padding: "0px 16px",
    backgroundColor: "var(--app-surface)",
    color: "var(--app-text)",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05), 0 0 0 4px #F2F4F7",
    "&:hover": {
      backgroundColor: "var(--app-surface)",
    },
    "& .mantine-Button-inner": {
      justifyContent: "flex-start",
    },
  },
  datePickerParent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width:834px)": {
      display: "block",
    },
  },
  popOverCard: {
    // Positioning now handled by Popover's own shift/flip middleware (see
    // DateRangePicker.jsx) + withinPortal — the old hardcoded per-breakpoint
    // `left` overrides fought that and are no longer needed.
  },
  buttonsParent: {
    borderRight: "1px solid #F5F5F5",
    display: "flex",
    flexDirection: "column",
    padding: "0 10px 0 0",
    "@media (max-width:834px)": {
      borderRight: "none",
    },
  },
  datePickerParentDiv: {
    // padding: "10px 0 10px 0",
  },
  datePicker: {
    padding: "0 10px 0 10px",
     "& .mantine-DatePicker-day[data-outside]": {
    opacity: 1,
    color: "inherit",   // or "#000" if you want fully normal
    pointerEvents: "auto", // 👈 ensures clickable
  },
  "& .mantine-DatePicker-day[data-in-range]": {
    backgroundColor: "var(--app-primary-soft, #FFF6E9)",
    "&:hover": {
      backgroundColor: "var(--app-primary-soft, #FFF6E9)",
    },
  },
  "& .mantine-DatePicker-day[data-selected]": {
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    "&:hover": {
      backgroundColor: "var(--app-primary)",
    },
  },
},
  

  dateButtons: {
    width: "auto",
    marginTop: "12px",
    transition: "0.5s",
    backgroundColor: "transparent",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#F5F5F5",
      color: "#262626",
    },
    color: "#000000",
    "@media (max-width:834px)": {
      backgroundColor: "#262626",
      color: "#F5F5F5",
    },
  },
  activeButton: {
    backgroundColor: "#000",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#000",
      color: "#fff",
    },
  },
  bottomButtonsParent: {
    borderTop: "1px solid #F5F5F5",
    paddingTop: "10px",
  },
  bottomButtons: {
    marginLeft: "15px",
  },
  cancelButton: {
    backgroundColor: "#F5F5F5",
    color: "#262626",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  applyButton: {
    backgroundColor: "#262626",
    width: "55%",
    "&:hover": {
      backgroundColor: "#262626",
    },
  },
  iconCalendar: {
    margin: "0 8px 0 0",
  },
}));

export default useStyles;
